/* Auto-generated from libphonenumber-js getCountries() — do not edit by hand. */
export const PHONE_COUNTRIES = [
    {
        "iso": "CH",
        "code": "41"
    },
    {
        "iso": "FR",
        "code": "33"
    },
    {
        "iso": "DE",
        "code": "49"
    },
    {
        "iso": "IT",
        "code": "39"
    },
    {
        "iso": "BE",
        "code": "32"
    },
    {
        "iso": "AT",
        "code": "43"
    },
    {
        "iso": "LI",
        "code": "423"
    },
    {
        "iso": "LU",
        "code": "352"
    },
    {
        "iso": "GB",
        "code": "44"
    },
    {
        "iso": "US",
        "code": "1"
    },
    {
        "iso": "ES",
        "code": "34"
    },
    {
        "iso": "PT",
        "code": "351"
    },
    {
        "iso": "NL",
        "code": "31"
    },
    {
        "iso": "AC",
        "code": "247"
    },
    {
        "iso": "AD",
        "code": "376"
    },
    {
        "iso": "AE",
        "code": "971"
    },
    {
        "iso": "AF",
        "code": "93"
    },
    {
        "iso": "AG",
        "code": "1"
    },
    {
        "iso": "AI",
        "code": "1"
    },
    {
        "iso": "AL",
        "code": "355"
    },
    {
        "iso": "AM",
        "code": "374"
    },
    {
        "iso": "AO",
        "code": "244"
    },
    {
        "iso": "AR",
        "code": "54"
    },
    {
        "iso": "AS",
        "code": "1"
    },
    {
        "iso": "AU",
        "code": "61"
    },
    {
        "iso": "AW",
        "code": "297"
    },
    {
        "iso": "AX",
        "code": "358"
    },
    {
        "iso": "AZ",
        "code": "994"
    },
    {
        "iso": "BA",
        "code": "387"
    },
    {
        "iso": "BB",
        "code": "1"
    },
    {
        "iso": "BD",
        "code": "880"
    },
    {
        "iso": "BF",
        "code": "226"
    },
    {
        "iso": "BG",
        "code": "359"
    },
    {
        "iso": "BH",
        "code": "973"
    },
    {
        "iso": "BI",
        "code": "257"
    },
    {
        "iso": "BJ",
        "code": "229"
    },
    {
        "iso": "BL",
        "code": "590"
    },
    {
        "iso": "BM",
        "code": "1"
    },
    {
        "iso": "BN",
        "code": "673"
    },
    {
        "iso": "BO",
        "code": "591"
    },
    {
        "iso": "BQ",
        "code": "599"
    },
    {
        "iso": "BR",
        "code": "55"
    },
    {
        "iso": "BS",
        "code": "1"
    },
    {
        "iso": "BT",
        "code": "975"
    },
    {
        "iso": "BW",
        "code": "267"
    },
    {
        "iso": "BY",
        "code": "375"
    },
    {
        "iso": "BZ",
        "code": "501"
    },
    {
        "iso": "CA",
        "code": "1"
    },
    {
        "iso": "CC",
        "code": "61"
    },
    {
        "iso": "CD",
        "code": "243"
    },
    {
        "iso": "CF",
        "code": "236"
    },
    {
        "iso": "CG",
        "code": "242"
    },
    {
        "iso": "CI",
        "code": "225"
    },
    {
        "iso": "CK",
        "code": "682"
    },
    {
        "iso": "CL",
        "code": "56"
    },
    {
        "iso": "CM",
        "code": "237"
    },
    {
        "iso": "CN",
        "code": "86"
    },
    {
        "iso": "CO",
        "code": "57"
    },
    {
        "iso": "CR",
        "code": "506"
    },
    {
        "iso": "CU",
        "code": "53"
    },
    {
        "iso": "CV",
        "code": "238"
    },
    {
        "iso": "CW",
        "code": "599"
    },
    {
        "iso": "CX",
        "code": "61"
    },
    {
        "iso": "CY",
        "code": "357"
    },
    {
        "iso": "CZ",
        "code": "420"
    },
    {
        "iso": "DJ",
        "code": "253"
    },
    {
        "iso": "DK",
        "code": "45"
    },
    {
        "iso": "DM",
        "code": "1"
    },
    {
        "iso": "DO",
        "code": "1"
    },
    {
        "iso": "DZ",
        "code": "213"
    },
    {
        "iso": "EC",
        "code": "593"
    },
    {
        "iso": "EE",
        "code": "372"
    },
    {
        "iso": "EG",
        "code": "20"
    },
    {
        "iso": "EH",
        "code": "212"
    },
    {
        "iso": "ER",
        "code": "291"
    },
    {
        "iso": "ET",
        "code": "251"
    },
    {
        "iso": "FI",
        "code": "358"
    },
    {
        "iso": "FJ",
        "code": "679"
    },
    {
        "iso": "FK",
        "code": "500"
    },
    {
        "iso": "FM",
        "code": "691"
    },
    {
        "iso": "FO",
        "code": "298"
    },
    {
        "iso": "GA",
        "code": "241"
    },
    {
        "iso": "GD",
        "code": "1"
    },
    {
        "iso": "GE",
        "code": "995"
    },
    {
        "iso": "GF",
        "code": "594"
    },
    {
        "iso": "GG",
        "code": "44"
    },
    {
        "iso": "GH",
        "code": "233"
    },
    {
        "iso": "GI",
        "code": "350"
    },
    {
        "iso": "GL",
        "code": "299"
    },
    {
        "iso": "GM",
        "code": "220"
    },
    {
        "iso": "GN",
        "code": "224"
    },
    {
        "iso": "GP",
        "code": "590"
    },
    {
        "iso": "GQ",
        "code": "240"
    },
    {
        "iso": "GR",
        "code": "30"
    },
    {
        "iso": "GT",
        "code": "502"
    },
    {
        "iso": "GU",
        "code": "1"
    },
    {
        "iso": "GW",
        "code": "245"
    },
    {
        "iso": "GY",
        "code": "592"
    },
    {
        "iso": "HK",
        "code": "852"
    },
    {
        "iso": "HN",
        "code": "504"
    },
    {
        "iso": "HR",
        "code": "385"
    },
    {
        "iso": "HT",
        "code": "509"
    },
    {
        "iso": "HU",
        "code": "36"
    },
    {
        "iso": "ID",
        "code": "62"
    },
    {
        "iso": "IE",
        "code": "353"
    },
    {
        "iso": "IL",
        "code": "972"
    },
    {
        "iso": "IM",
        "code": "44"
    },
    {
        "iso": "IN",
        "code": "91"
    },
    {
        "iso": "IO",
        "code": "246"
    },
    {
        "iso": "IQ",
        "code": "964"
    },
    {
        "iso": "IR",
        "code": "98"
    },
    {
        "iso": "IS",
        "code": "354"
    },
    {
        "iso": "JE",
        "code": "44"
    },
    {
        "iso": "JM",
        "code": "1"
    },
    {
        "iso": "JO",
        "code": "962"
    },
    {
        "iso": "JP",
        "code": "81"
    },
    {
        "iso": "KE",
        "code": "254"
    },
    {
        "iso": "KG",
        "code": "996"
    },
    {
        "iso": "KH",
        "code": "855"
    },
    {
        "iso": "KI",
        "code": "686"
    },
    {
        "iso": "KM",
        "code": "269"
    },
    {
        "iso": "KN",
        "code": "1"
    },
    {
        "iso": "KP",
        "code": "850"
    },
    {
        "iso": "KR",
        "code": "82"
    },
    {
        "iso": "KW",
        "code": "965"
    },
    {
        "iso": "KY",
        "code": "1"
    },
    {
        "iso": "KZ",
        "code": "7"
    },
    {
        "iso": "LA",
        "code": "856"
    },
    {
        "iso": "LB",
        "code": "961"
    },
    {
        "iso": "LC",
        "code": "1"
    },
    {
        "iso": "LK",
        "code": "94"
    },
    {
        "iso": "LR",
        "code": "231"
    },
    {
        "iso": "LS",
        "code": "266"
    },
    {
        "iso": "LT",
        "code": "370"
    },
    {
        "iso": "LV",
        "code": "371"
    },
    {
        "iso": "LY",
        "code": "218"
    },
    {
        "iso": "MA",
        "code": "212"
    },
    {
        "iso": "MC",
        "code": "377"
    },
    {
        "iso": "MD",
        "code": "373"
    },
    {
        "iso": "ME",
        "code": "382"
    },
    {
        "iso": "MF",
        "code": "590"
    },
    {
        "iso": "MG",
        "code": "261"
    },
    {
        "iso": "MH",
        "code": "692"
    },
    {
        "iso": "MK",
        "code": "389"
    },
    {
        "iso": "ML",
        "code": "223"
    },
    {
        "iso": "MM",
        "code": "95"
    },
    {
        "iso": "MN",
        "code": "976"
    },
    {
        "iso": "MO",
        "code": "853"
    },
    {
        "iso": "MP",
        "code": "1"
    },
    {
        "iso": "MQ",
        "code": "596"
    },
    {
        "iso": "MR",
        "code": "222"
    },
    {
        "iso": "MS",
        "code": "1"
    },
    {
        "iso": "MT",
        "code": "356"
    },
    {
        "iso": "MU",
        "code": "230"
    },
    {
        "iso": "MV",
        "code": "960"
    },
    {
        "iso": "MW",
        "code": "265"
    },
    {
        "iso": "MX",
        "code": "52"
    },
    {
        "iso": "MY",
        "code": "60"
    },
    {
        "iso": "MZ",
        "code": "258"
    },
    {
        "iso": "NA",
        "code": "264"
    },
    {
        "iso": "NC",
        "code": "687"
    },
    {
        "iso": "NE",
        "code": "227"
    },
    {
        "iso": "NF",
        "code": "672"
    },
    {
        "iso": "NG",
        "code": "234"
    },
    {
        "iso": "NI",
        "code": "505"
    },
    {
        "iso": "NO",
        "code": "47"
    },
    {
        "iso": "NP",
        "code": "977"
    },
    {
        "iso": "NR",
        "code": "674"
    },
    {
        "iso": "NU",
        "code": "683"
    },
    {
        "iso": "NZ",
        "code": "64"
    },
    {
        "iso": "OM",
        "code": "968"
    },
    {
        "iso": "PA",
        "code": "507"
    },
    {
        "iso": "PE",
        "code": "51"
    },
    {
        "iso": "PF",
        "code": "689"
    },
    {
        "iso": "PG",
        "code": "675"
    },
    {
        "iso": "PH",
        "code": "63"
    },
    {
        "iso": "PK",
        "code": "92"
    },
    {
        "iso": "PL",
        "code": "48"
    },
    {
        "iso": "PM",
        "code": "508"
    },
    {
        "iso": "PR",
        "code": "1"
    },
    {
        "iso": "PS",
        "code": "970"
    },
    {
        "iso": "PW",
        "code": "680"
    },
    {
        "iso": "PY",
        "code": "595"
    },
    {
        "iso": "QA",
        "code": "974"
    },
    {
        "iso": "RE",
        "code": "262"
    },
    {
        "iso": "RO",
        "code": "40"
    },
    {
        "iso": "RS",
        "code": "381"
    },
    {
        "iso": "RU",
        "code": "7"
    },
    {
        "iso": "RW",
        "code": "250"
    },
    {
        "iso": "SA",
        "code": "966"
    },
    {
        "iso": "SB",
        "code": "677"
    },
    {
        "iso": "SC",
        "code": "248"
    },
    {
        "iso": "SD",
        "code": "249"
    },
    {
        "iso": "SE",
        "code": "46"
    },
    {
        "iso": "SG",
        "code": "65"
    },
    {
        "iso": "SH",
        "code": "290"
    },
    {
        "iso": "SI",
        "code": "386"
    },
    {
        "iso": "SJ",
        "code": "47"
    },
    {
        "iso": "SK",
        "code": "421"
    },
    {
        "iso": "SL",
        "code": "232"
    },
    {
        "iso": "SM",
        "code": "378"
    },
    {
        "iso": "SN",
        "code": "221"
    },
    {
        "iso": "SO",
        "code": "252"
    },
    {
        "iso": "SR",
        "code": "597"
    },
    {
        "iso": "SS",
        "code": "211"
    },
    {
        "iso": "ST",
        "code": "239"
    },
    {
        "iso": "SV",
        "code": "503"
    },
    {
        "iso": "SX",
        "code": "1"
    },
    {
        "iso": "SY",
        "code": "963"
    },
    {
        "iso": "SZ",
        "code": "268"
    },
    {
        "iso": "TA",
        "code": "290"
    },
    {
        "iso": "TC",
        "code": "1"
    },
    {
        "iso": "TD",
        "code": "235"
    },
    {
        "iso": "TG",
        "code": "228"
    },
    {
        "iso": "TH",
        "code": "66"
    },
    {
        "iso": "TJ",
        "code": "992"
    },
    {
        "iso": "TK",
        "code": "690"
    },
    {
        "iso": "TL",
        "code": "670"
    },
    {
        "iso": "TM",
        "code": "993"
    },
    {
        "iso": "TN",
        "code": "216"
    },
    {
        "iso": "TO",
        "code": "676"
    },
    {
        "iso": "TR",
        "code": "90"
    },
    {
        "iso": "TT",
        "code": "1"
    },
    {
        "iso": "TV",
        "code": "688"
    },
    {
        "iso": "TW",
        "code": "886"
    },
    {
        "iso": "TZ",
        "code": "255"
    },
    {
        "iso": "UA",
        "code": "380"
    },
    {
        "iso": "UG",
        "code": "256"
    },
    {
        "iso": "UY",
        "code": "598"
    },
    {
        "iso": "UZ",
        "code": "998"
    },
    {
        "iso": "VA",
        "code": "39"
    },
    {
        "iso": "VC",
        "code": "1"
    },
    {
        "iso": "VE",
        "code": "58"
    },
    {
        "iso": "VG",
        "code": "1"
    },
    {
        "iso": "VI",
        "code": "1"
    },
    {
        "iso": "VN",
        "code": "84"
    },
    {
        "iso": "VU",
        "code": "678"
    },
    {
        "iso": "WF",
        "code": "681"
    },
    {
        "iso": "WS",
        "code": "685"
    },
    {
        "iso": "XK",
        "code": "383"
    },
    {
        "iso": "YE",
        "code": "967"
    },
    {
        "iso": "YT",
        "code": "262"
    },
    {
        "iso": "ZA",
        "code": "27"
    },
    {
        "iso": "ZM",
        "code": "260"
    },
    {
        "iso": "ZW",
        "code": "263"
    }
];
